const facebook = {
  injectScript: (appId: String) => {
    if (!facebook.scriptInjected) {
      facebook.scriptInjected = true;

      window.fbAsyncInit = function () {
        window.FB?.init({
          appId,
          version: 'v3.2',
          xfbml: true
        });
      };

      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0]!;
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s) as HTMLScriptElement;
        js.id = id;
        js.src = '//connect.facebook.net/en_US/sdk.js';
        fjs.parentNode?.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    } else {
      window?.FB?.XFBML?.parse();
    }
  },
  scriptInjected: false
};

const instagram = {
  injectScript: () => {
    if (!instagram.scriptInjected) {
      instagram.scriptInjected = true;

      const scriptId = 'instagram-sdk';

      if (document.getElementById(scriptId)) return;

      const scriptTags = document.getElementsByTagName('script')[0]!;

      const embed = document.createElement('script');
      embed.id = scriptId;
      embed.src = '//www.instagram.com/embed.js';

      scriptTags.parentNode?.insertBefore(embed, scriptTags);
    } else {
      window.instgrm?.Embeds.process();
      window.__igEmbedLoaded = () => {
        window.instgrm?.Embeds.process();
      };
    }
  },
  scriptInjected: false
};

const twitter = {
  injectScript: () => {
    if (!twitter.scriptInjected) {
      twitter.scriptInjected = true;

      const scriptId = 'twitter-sdk';

      if (document.getElementById(scriptId)) return;

      const scriptTags = document.getElementsByTagName('script')[0]!;

      const embed = document.createElement('script');
      embed.id = scriptId;
      embed.src = '//platform.twitter.com/widgets.js';

      scriptTags.parentNode?.insertBefore(embed, scriptTags);
    }
  },
  scriptInjected: false
};

export default {
  injectFacebook: facebook.injectScript,
  injectInstagram: instagram.injectScript,
  injectTwitter: twitter.injectScript
};
